import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png"; // optional background image

const ConsumerComplaintsHandling = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Consumer Complaints Handling</h1>
          <p className="subtitle">
            MBS ensures that consumer complaints are handled professionally, promoting quality and accountability.
          </p>
        </div>
      </section>

      {/* === Overview Section === */}
      <section className="what-section">
        <p className="paragraph">
          The Quality Assurance Services Department also handles consumer complaints for local and imported products by investigations and testing against relevant standards under the certification schemes. The complaints are handled with the aim of addressing the origin of the problem (for the manufacturer), or compensation to the consumer. From the results of the investigations and testing, reports are made and communicated to the complainant and the manufacturer or trader for their action, and improvement, as applicable.
        </p>
      </section>

      <br /><br />

      {/* === Inline Styles === */}
      <style>{`
        .about-us { font-family: Arial, sans-serif; color: #333; }
        .about-header {
          background-image: url(${headerBg});
          background-size: cover;
          background-position: center;
          height: 45vh;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }
        .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          box-sizing: border-box;
          border-radius: 8px;
        }
        .page-title { font-size: 2.5rem; font-weight: bold; }
        .subtitle { margin-top: 10px; font-size: 1rem; }
        .what-section { padding: 50px 80px; }
        .paragraph { font-size: 1rem; line-height: 1.7; margin: 15px 0; text-align: left; }
        @media screen and (max-width: 768px) {
          .what-section { padding: 25px 20px; }
          .page-title { font-size: 2rem; }
          .overlay { width: 95%; padding: 25px; }
        }
      `}</style>
    </div>
  );
};

export default ConsumerComplaintsHandling;
